import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';
import { Form } from 'components/@shared/Form/Form';
import { FormTextField } from 'components/@shared/Form/TextField';
import { Box, Button, Stack, Typography } from '@mui/material';
import { initialValues } from './constants';
import { validationSchema } from './validation';

interface Props {
    onReset: (email: string) => void;
}

export const ResetPasswordForm = ({ onReset }: Props) => {
    const navigate = useNavigate();

    const submitHandler = useCallback(
        ({ email }: { email: string }) => onReset(email),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    const goBackHandler = useCallback(
        () => navigate(-1),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return (
        <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={submitHandler}>
            <Stack maxWidth={380} pt={5} pb={3} mx="auto" gap={1}>
                <FormTextField name="email" label="Email" fullWidth size="small" />
                <Typography variant="body2">You will receive a link to reset your password.</Typography>
                <Stack direction="row" pt={2} gap={2} width="100%">
                    <Button onClick={goBackHandler} fullWidth>
                        Go Back
                    </Button>
                    <Button variant="contained" type="submit" fullWidth>
                        Send
                    </Button>
                </Stack>
            </Stack>
        </Form>
    );
};
